module.exports = __webpack_public_path__ + "img/back.16733c83.svg";